// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import {
   formatFloatAsCurrencySymbol,
   formatFloatAsPercent,
} from '../../../common/helpers.mjs'
import { shouldDisableDiscount } from '../../../js/validate'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Asset Imports

export default function QuickStartTrainingDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const discountCode = 'quickstartDiscount'
   const { getString } = state

   if (state.user_view == 'Internal' || state.discountQuickstartTraining)
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list[discountCode]['DiscountDescription']
                  }
                  discountName={
                     state.discount_list[discountCode]['DiscountName']
                  }
                  hoverTitle={getString(
                     'product.QuickStartTrainingDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountQuickstartTraining}
                  disabled={shouldDisableDiscount(state, discountCode)}
                  onChange={() =>
                     state.setDiscountQuickstartTraining((prev) => !prev)
                  }
               />
            </div>
            <div className='col'>
               {state.discountDealDeskQuickstartImpRate != null &&
               state.discountDealDeskQuickstartImpRate != 0
                  ? formatFloatAsPercent(
                       state.discount_list[discountCode]['DiscountAmount'],
                    )
                  : formatFloatAsCurrencySymbol(
                       state.discount_list[discountCode]['DiscountAmount'],
                       state.currencyObject,
                    )}
            </div>
         </div>
      )
}
